var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlanket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 1H4.5C2.568 1 1 2.568 1 4.5V11.5C1 13.432 2.568 15 4.5 15H12.9C14.055 15 15 14.055 15 12.9C15 11.745 14.055 10.8 12.9 10.8H3.8V12.2H12.9C13.285 12.2 13.6 12.515 13.6 12.9C13.6 13.285 13.285 13.6 12.9 13.6H4.5C3.345 13.6 2.4 12.655 2.4 11.5C2.4 10.345 3.345 9.4 4.5 9.4H13.6C14.37 9.4 15 8.77 15 8V2.4C15 1.63 14.37 1 13.6 1ZM13.6 8H4.5C3.716 8 2.988 8.259 2.4 8.7V4.5C2.4 3.345 3.345 2.4 4.5 2.4H13.6V8Z",
    fill: "url(#paint0_linear_277_44035)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_277_44035",
    x1: 1,
    y1: 8,
    x2: 15,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlanket);
export default __webpack_public_path__ + "static/media/blanket.67505bc571f4bcf35f3aec946bb034ab.svg";
export { ForwardRef as ReactComponent };